export default __webpack_public_path__ + "static/media/illustration-health-1-w.c7153e89.webp";